import { cva, type VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'

import { cn } from '../../lib/cn'

const variantesBadge = cva(
    'inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium leading-none whitespace-nowrap',
    {
        variants: {
            tone: {
                neutral: 'bg-neutral-800 text-neutral-300',
                danger: 'bg-red-950 text-red-300',
                warning: 'bg-amber-950 text-amber-300',
                info: 'bg-sky-950 text-sky-300',
                success: 'bg-emerald-950 text-emerald-300',
            },
        },
        defaultVariants: { tone: 'neutral' },
    },
)

export interface PropsBadge extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof variantesBadge> {}

export function Badge({ className, tone, ...props }: PropsBadge) {
    return <span className={cn(variantesBadge({ tone }), className)} {...props} />
}
